import { type ReactNode } from "react";
import { MailLocalStorageSection } from "@/features/accounts/MailLocalStorageSection";
import { cn } from "@/lib/cn";
import type { MailFolder } from "@/lib/types/mail";

type Props = {
  accountId: number;
  folders: MailFolder[];
  active?: boolean;
  sectionPadding?: "default" | "compact";
  onPurged?: () => void;
};

function SettingsBlock({
  title,
  children,
  compact,
}: {
  title: string;
  children: ReactNode;
  compact?: boolean;
}) {
  return (
    <section
      className={cn(
        "space-y-3 border-b border-[var(--mail-border-soft)] py-4 last:border-b-0",
        compact ? "px-4" : "px-5"
      )}
    >
      <h3 className="text-[10px] font-semibold uppercase tracking-wider text-[var(--mail-muted)]">
        {title}
      </h3>
      {children}
    </section>
  );
}

/** Paramètres compte — stockage .eml sur DD02 serveur. */
export function MailStorageSettingsPanel({
  accountId,
  folders,
  active = true,
  sectionPadding = "default",
  onPurged,
}: Props) {
  const compact = sectionPadding === "compact";

  return (
    <SettingsBlock title="Stockage serveur" compact={compact}>
      <MailLocalStorageSection
        accountId={accountId}
        folders={folders}
        active={active}
        compact={compact}
        onPurged={onPurged}
      />
    </SettingsBlock>
  );
}
